<template>
  <div class="zadi-session-check-ins">
    <!-- ننتظر الجلسة حتى تُبنى أزرار الصفوف بحالتها الصحيحة -->
    <ag-table
      v-if="session"
      :data-source-api="getAllCheckIns"
      :grid-options="gridOptions"
      :permissions="permissions"
      :is-entities-response="false"
      @emitExportToExcel="onExportToExcel"
      :rtl="false"
    >
      <template #action>
        <button v-can="permissions.edit" class="action-button add" :disabled="isSessionClosed"
          @click="onAddVolunteers()">
          إضافة متطوعين
        </button>
        <button v-can="permissions.edit" class="action-button cancel" @click="onCancelVolunteers()">
          إلغاء متطوعين
        </button>
        <button v-can="permissions.edit" class="action-button complete" :disabled="!isSessionRunning"
          @click="onCompleteSession()">
          إنهاء الجلسة
        </button>
      </template>
    </ag-table>

    <tm-popup :submit="onCheckInPopupSubmit" title="تعديل حالة الحضور" ref="checkInPopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-select class="w-full" name="حالة الحضور" placeholder="حالة الحضور" :options="checkInStatusOptions"
            label="name" validation-rules="required" :reduce="(option) => option.value" v-model="checkInForm.status" />
        </div>
      </div>
    </tm-popup>

    <zadi-check-in-history ref="historyPopup" :session-id="$route.params.id" :status-labels="checkInStatus" />

    <tm-popup :submit="onCancelPopupSubmit" title="إلغاء متطوعين من الجلسة" ref="cancelPopup"
      submit-button-label="متابعة">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-select class="w-full" name="المجموعات" placeholder="اختر المجموعات" :options="groupNameOptions"
            validation-rules="" multiple :reduce="(groupName) => groupName" v-model="cancelForm.groupNames" />
        </div>
        <div class="vx-col w-full mb-2 mt-4">
          <p v-if="selectedVolunteersCount">
            المتطوعون المحددون في الجدول: {{ selectedVolunteersCount }}
          </p>
          <p class="text-danger" v-else-if="!cancelForm.groupNames.length">
            لم تحدد مجموعات، سيتم إلغاء كامل متطوعي الجلسة.
          </p>
          <!-- <p class="text-danger" v-else-if="!cancelForm.groupNames.length">
            لم تحدد مجموعات ولا متطوعين، سيتم إلغاء كامل متطوعي الجلسة.
          </p> -->
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "@/app/shared/shared-components/ag-grid/AgTableServerSide";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import ZadiCheckInHistory from "../../components/ZadiCheckInHistory";
import utilities from "@/app/shared/utilities/index";

const zadiSessionsRepo = RepositoryFactory.get("zadiSessionsRepository");
const supervisorsRepo = RepositoryFactory.get("supervisorsRepository");

export default {
  name: "ZadiSessionCheckIns",
  components: {
    AgTable,
    TmPopup,
    TmSelect,
    ZadiCheckInHistory,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      apiQuery: "",
      session: null,
      permissions: {
        add: "training_courses_management",
        edit: "training_courses_management",
        delete: "training_courses_management",
      },
      checkInStatus: {
        attended: "حضر",
        no_show: "لم يحضر",
        unregistered_attended: "حضر دون تسجيل",
      },
      checkInForm: {
        volunteerId: null,
        status: null,
      },
      volunteerGroups: [],
      cancelForm: {
        groupNames: [],
      },
      selectedVolunteersCount: 0,
    };
  },
  computed: {
    checkInStatusOptions() {
      return Object.keys(this.checkInStatus).map((value) => ({
        value,
        name: this.checkInStatus[value],
      }));
    },
    groupNameOptions() {
      return this.volunteerGroups.map((group) => group.name);
    },
    isSessionRunning() {
      return !!this.session && ["published", "in_progress"].includes(this.session.status);
    },
    // إضافة المتطوعين مرفوضة من السيرفر بعد تسوية الكوبونات
    isSessionClosed() {
      return !!this.session && ["completed", "cancelled"].includes(this.session.status);
    },
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "معرف المتطوع",
          field: "volunteerId",
          width: 200,
          sortable: false,
          // checkboxSelection: true,
        },
        {
          headerName: "اسم المتطوع",
          field: "volunteer.name",
          filter: "agTextColumnFilter",
          width: 220,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.volunteer ? params.data.volunteer.name : "-";
          },
        },
        {
          headerName: "رقم البطاقة",
          field: "volunteer.cardNumber",
          filter: "agTextColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.volunteer ? params.data.volunteer.cardNumber : "-";
          },
        },
        {
          headerName: "المجموعة",
          field: "volunteer.volunteerInfo.groupName",
          filter: "agTextColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.volunteer && params.data.volunteer.volunteerInfo
              ? params.data.volunteer.volunteerInfo.groupName || "-"
              : "-";
          },
        },
        // {
        //   headerName: "مسجّل",
        //   field: "isConfirmed",
        //   width: 150,
        //   sortable: false,
        //   valueGetter: function getObject(params) {
        //     return params.data.isConfirmed ? "نعم" : "لا";
        //   },
        // },
        {
          headerName: "حالة الحضور",
          field: "checkInStatus",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.checkInStatus[params.data.checkInStatus] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: [...Object.keys(self.checkInStatus), "null"],
            valueFormatter: (params) =>
              params.value === "null" ? "-" : self.checkInStatus[params.value] || params.value,
          },
        },
        {
          headerName: "وقت تسجيل الحضور",
          field: "checkedInAt",
          width: 220,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.checkedInAt
              ? utilities.formatDate(params.data.checkedInAt, "yyyy-MM-DD HH:mm")
              : "-";
          },
        },
        {
          headerName: "سجّل الحضور",
          field: "checkedInBySupervisor.name",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.checkedInBySupervisor ? params.data.checkedInBySupervisor.name : "-";
          },
        },
        {
          headerName: "السجل",
          width: 160,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: () => {
            return {
              size: "small",
              color: "primary",
              name: "السجل",
              type: "gradient",
              permission: self.permissions.edit,
              click(checkIn) {
                self.$refs.historyPopup.open(checkIn);
              },
            };
          },
        },
        {
          headerName: "تعديل الحضور",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: () => {
            return {
              size: "small",
              color: "primary",
              name: "تعديل الحضور",
              type: "gradient",
              permission: self.permissions.edit,
              click(checkIn) {
                self.onUpdateCheckIn(checkIn);
              },
            };
          },
        },
        {
          headerName: "تراجع عن الحضور",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "تراجع عن الحضور",
              type: "gradient",
              permission: self.permissions.edit,
              disabled: !params.data.checkInStatus,
              click(checkIn) {
                self.onResetCheckIn(checkIn);
              },
            };
          },
        },
        {
          headerName: "إلغاء التسجيل",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "إلغاء التسجيل",
              type: "gradient",
              permission: self.permissions.edit,
              // يُرفض الإلغاء لمن لا تسجيل مؤكداً له، ولا قيود على حالة الجلسة أو تاريخها
              disabled: params.data.isConfirmed === false,
              click(checkIn) {
                self.onCancelRegistration(checkIn);
              },
            };
          },
        },
      ];
    },
    getGridApi() {
      return this.gridApi || (this.gridOptions && this.gridOptions.api) || null;
    },
    refreshTable() {
      const gridApi = this.getGridApi();
      if (gridApi) gridApi.refreshServerSideStore({ purge: true });
    },
    async getSession() {
      this.session = await zadiSessionsRepo.getZadiSession(this.$route.params.id);
    },
    async getVolunteerGroups() {
      const response = await supervisorsRepo.fetchVolunteerGroups();
      this.volunteerGroups = response.data || [];
    },
    async getAllCheckIns(query) {
      // $in لا يقبل null، فخيار "-" وحده يُرسل كـ $isnull
      query = query.replace(/filter=checkInStatus\|\|\$in\|\|null(?=&|$)/, "filter=checkInStatus||$isnull");
      this.apiQuery = query;
      return await zadiSessionsRepo.fetchZadiSessionCheckIns(this.$route.params.id, query);
    },
    async onExportToExcel() {
      await zadiSessionsRepo.exportZadiSessionCheckIns(this.$route.params.id, this.apiQuery);
    },
    onUpdateCheckIn(checkIn) {
      this.checkInForm = {
        volunteerId: checkIn.volunteerId,
        status: checkIn.checkInStatus || null,
      };
      this.$refs.checkInPopup.open();
    },
    async onCheckInPopupSubmit() {
      try {
        await zadiSessionsRepo.updateZadiSessionCheckIn(
          this.$route.params.id,
          this.checkInForm.volunteerId,
          this.checkInForm.status
        );
        this.$refs.checkInPopup.close();
        this.refreshTable();
      } catch (err) {
        this.$refs.checkInPopup.endLoading();
      }
    },
    onResetCheckIn(checkIn) {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "تراجع عن الحضور",
        text: "سيعود المتطوع إلى حالة قيد الانتظار مع الإبقاء على تسجيله في الجلسة.",
        acceptText: "تراجع",
        cancelText: "إلغاء",
        accept: () => this.resetCheckIn(checkIn),
      });
    },
    async resetCheckIn(checkIn) {
      await zadiSessionsRepo.removeZadiSessionCheckIn(this.$route.params.id, checkIn.volunteerId);
      this.refreshTable();
    },
    onAddVolunteers() {
      this.$router.push({ path: `/volunteers/zadi-sessions/${this.$route.params.id}/add-volunteers` });
    },
    onCancelRegistration(checkIn) {
      const name = checkIn.volunteer ? checkIn.volunteer.name : "";
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "إلغاء التسجيل",
        text: `سيتم إلغاء تسجيل المتطوع "${name}" في الجلسة وإعادة مقعده. يمكن إضافته مجدداً لاحقاً.`,
        acceptText: "إلغاء التسجيل",
        cancelText: "تراجع",
        accept: () => this.cancelRegistration(checkIn),
      });
    },
    async cancelRegistration(checkIn) {
      await zadiSessionsRepo.cancelZadiSessionRegistration(this.$route.params.id, checkIn.volunteerId);
      this.$vs.notify({
        title: "إلغاء التسجيل",
        color: "success",
        text: "تم إلغاء تسجيل المتطوع وإعادة مقعده.",
      });
      this.refreshTable();
    },
    onCancelVolunteers() {
      this.cancelForm = { groupNames: [] };
      this.selectedVolunteersCount = this.getSelectedVolunteerIds().length;
      this.$refs.cancelPopup.open();
    },
    getSelectedVolunteerIds() {
      const gridApi = this.getGridApi();
      if (!gridApi) return [];
      return gridApi.getSelectedRows().map((checkIn) => checkIn.volunteerId);
    },
    onCancelPopupSubmit() {
      const payload = {
        groupNames: this.cancelForm.groupNames,
        // volunteerIds: this.getSelectedVolunteerIds(),
      };
      const isCancellingAll = !payload.groupNames.length;
      this.$refs.cancelPopup.close();
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "إلغاء متطوعين من الجلسة",
        text: isCancellingAll
          ? "سيتم إلغاء كامل متطوعي الجلسة وإشعارهم بذلك. لا يمكن التراجع عن هذا الإجراء."
          : "سيتم إلغاء المتطوعين المحددين وإشعارهم بذلك. لا يمكن التراجع عن هذا الإجراء.",
        acceptText: "إلغاء التسجيل",
        cancelText: "تراجع",
        accept: () => this.cancelVolunteers(payload),
      });
    },
    async cancelVolunteers(payload) {
      const response = await zadiSessionsRepo.cancelZadiSessionVolunteers(
        this.$route.params.id,
        payload
      );
      if (response && response.data && response.data.cancelledCount != null) {
        this.$vs.notify({
          title: "إلغاء متطوعين من الجلسة",
          color: "success",
          text: `عدد المتطوعين الملغيين: ${response.data.cancelledCount}`,
        });
      }
      this.refreshTable();
    },
    onCompleteSession() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: "إنهاء الجلسة",
        text: "سيتم إنهاء الجلسة. لا يمكن التراجع عن هذا الإجراء.",
        acceptText: "إنهاء",
        cancelText: "إلغاء",
        accept: () => this.completeSession(),
      });
    },
    async completeSession() {
      const response = await zadiSessionsRepo.completeZadiSession(this.$route.params.id);
      if (response && response.data && response.data.noShowCount != null) {
        this.$vs.notify({
          title: "إنهاء الجلسة",
          color: "success",
          text: `تم إنهاء الجلسة بنجاح. عدد المتغيبين: ${response.data.noShowCount}`,
        });
      }
      await this.getSession();
      this.refreshTable();
    },
  },
  created() {
    this.gridOptions = {
      // rowSelection: "multiple",
      // rowMultiSelectWithClick: true,
      // suppressRowClickSelection: true,
      // onGridReady: (params) => {
      //   this.gridApi = params.api;
      // },
    };
    this.gridOptions.columnDefs = this.createColDefs();
    this.getSession();
    this.getVolunteerGroups();
  },
  mounted() {
    if (!this.gridApi) this.gridApi = this.gridOptions.api;
  },
};
</script>

<style scoped>
.action-button {
  cursor: pointer;
  outline: none;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
}

.action-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button.complete {
  background: #85cd5f;
}

.action-button.add {
  background: #4b364e;
}

.action-button.cancel {
  background: #ef4141;
}
</style>
